// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 7: אִגְּרוֹת וְהִתְגַּלּוּת
// ============================================================================
// רמות 79-91 (13 רמות, 39 שאלות)

export const chapter7Translations = {
  name: "אִגְּרוֹת וְהִתְגַּלּוּת",
  description: "מִי שֶׁיִּנְצַח יִירַשׁ אֶת כָּל אֵלֶּה... חָכְמָה מִלְמַעְלָה מְקַדֶּשֶׁת אֶת הַשֵּׂכֶל",
  
  spiritualWisdom: {
    principle: "חָכְמָה מִלְמַעְלָה מְקַדֶּשֶׁת אֶת הַשֵּׂכֶל וּמְחַיָּה אֶת הָרוּחַ",
    scripture: "אִם חָסֵר לְאִישׁ מִכֶּם חָכְמָה, יִשְׁאַל מֵאֵת הָאֱלֹהִים (יַעֲקֹב 1:5)",
    application: "כָּל אִגֶּרֶת שְׁלִיחִית וְכָל חָזוֹן מֵהִתְגַּלּוּת מַעֲשִׁירִים אֶת הֲבָנָתֵנוּ וּמְחַזְּקִים אֶת תִּקְוָתֵנוּ"
  },
  
  levels: {
    79: {
      name: "מַעֲצָר בִּירוּשָׁלַיִם",
      challenge: "אֲנִי מוּכָן לֹא רַק לְהֵאָסֵר אֶלָּא גַּם לָמוּת בִּירוּשָׁלַיִם...",
      easy: {
        question: "אֵיפֹה נֶעֱצַר פּוֹלוֹס בְּבִקּוּרוֹ הָאַחֲרוֹן?",
        options: ["אַנְטְיוֹכְיָה", "אֶפֶסוֹס", "יְרוּשָׁלַיִם", "קוֹרִינְתוֹס"],
        correctAnswer: 2,
        hint: "הָעִיר הַקְּדוֹשָׁה שֶׁרָדְפָה לְעִתִּים קְרוֹבוֹת אֶת הַנְּבִיאִים",
        funFact: "🏛️ יְרוּשָׁלַיִם: מְקוֹם כָּבוֹד וְסֵבֶל לְכָל עַבְדֵי הָאֱלֹהִים!"
      },
      medium: {
        question: "בְּמָה הֵאֱשִׁימוּ הַיְּהוּדִים אֶת פּוֹלוֹס?",
        options: [
          "גְּנֵבָה מֵהַמִּקְדָּשׁ",
          "חִלּוּל הַמִּקְדָּשׁ בְּהַכְנָסַת גּוֹיִם",
          "חִלּוּל הַשֵּׁם נֶגֶד מֹשֶׁה",
          "מֶרֶד נֶגֶד רוֹמָא"
        ],
        correctAnswer: 1,
        hint: "הַאֲשָׁמָה הַקְּשׁוּרָה לְאוּנִיבֶרְסָלִיּוּת הַבְּשׂוֹרָה",
        funFact: "⛪ אִירוֹנְיָה: פּוֹלוֹס מֻאֲשָׁם בְּחִלּוּל הַמִּקְדָּשׁ שֶׁכִּבֵּד עֲמֻקָּה!"
      },
      hard: {
        question: "אֵיךְ הָפַךְ פּוֹלוֹס אֶת שִׁבְיוֹ לְהַזְדַּמְּנוּת?",
        options: [
          "הוּא בָּרַח",
          "הֵעִיד לִפְנֵי הָרְשׁוּיוֹת וְכָתַב אֶת אִגְּרוֹתָיו",
          "שָׁתַק",
          "מִשֵּׁא וּמַתָּן עַל שִׁחְרוּרוֹ"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּהִפּוּךְ הַנִּסָּיוֹן לְעֵדוּת",
        funFact: "⛓️ כְּבָלִים פִיזִיִּים, חֵרוּת רוּחָנִית - עֵדוּת חֲזָקָה לְאֱמוּנָה!"
      }
    },
    
    80: {
      name: "לִפְנֵי הַמּוֹשֵׁל פֵילִיקְס",
      challenge: "וּבְדַבְּרוֹ עַל הַצֶּדֶק וְהַפְּרִישׁוּת וְעַל הַמִּשְׁפָּט הֶעָתִיד לָבוֹא...",
      easy: {
        question: "לִפְנֵי אֵיזֶה מוֹשֵׁל הֵעִיד פּוֹלוֹס עַל אֱמוּנָתוֹ?",
        options: ["פִּילָטוֹס", "פֵילִיקְס", "פֶסְטוֹס", "גַּלְיוֹן"],
        correctAnswer: 1,
        hint: "מוֹשֵׁל יָדוּעַ בְּחַמְדָנוּתוֹ",
        funFact: "⚖️ פֵילִיקְס קִוָּה לְשֹׁחַד - שִׁחִיתוּת מוּל יוֹשֶׁר!"
      },
      medium: {
        question: "מָה הָיְתָה תְּגוּבַת פֵילִיקְס לִמְסַר פּוֹלוֹס?",
        options: [
          "הִתְגַּיֵּר",
          "נִבְעַת מִפַּחַד",
          "לָעַג",
          "נִשְׁאַר אֲדִישׁ"
        ],
        correctAnswer: 1,
        hint: "הַמַּצְפּוּן הַמֻּטְרָד מֵהָאֱמֶת",
        funFact: "😰 אֲפִילוּ הַמְּשֻׁחָדִים חוֹרְדִים לִפְנֵי הָאֱמֶת הָאֱלֹהִית - מַצְפּוּן אוּנִיבֶרְסָלִי!"
      },
      hard: {
        question: "לָמָּה הֶחֱזִיק פֵילִיקְס אֶת פּוֹלוֹס כָּלוּא שְׁנָתַיִם?",
        options: [
          "כְּדֵי לְהָגֵן עָלָיו",
          "מִתּוֹךְ אִינְטֶרֶס פּוֹלִיטִי וְתִקְוָה לְשִׁחִיתוּת",
          "מִשִּׁכְחָה",
          "מִשִּׁכְנוּעַ"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּחִשּׁוּבִים פּוֹלִיטִיִּים וְאִישִׁיִּים",
        funFact: "🏛️ צֶדֶק אֱנוֹשִׁי מְשֻׁחָד מוּל צֶדֶק אֱלֹהִי מֻשְׁלָם - נִיגּוּד בּוֹלֵט!"
      }
    },

    81: {
      name: "עֶרְעוּר לְקֵיסָר",
      challenge: "לְקֵיסָר אֲנִי קוֹרֵא!",
      easy: {
        question: "לְאֵיזוֹ זְכוּת פָּנָה פּוֹלוֹס כְּדֵי לְהִמָּנַע מִמִּשְׁפָּט בִּירוּשָׁלַיִם?",
        options: [
          "זְכוּת מִקְלָט",
          "עֶרְעוּר לְקֵיסָר (אֶזְרָח רוֹמִי)",
          "זְכוּת בְּרִיחָה",
          "הֲגַנָּה דִיפְלוֹמָטִית"
        ],
        correctAnswer: 1,
        hint: "פְּרִיבִילֶגְיָה שֶׁל אֶזְרָחוּתוֹ הָרוֹמִית",
        funFact: "🏛️ אֶזְרָחוּת רוֹמִית: דַּרְכּוֹן אֱלֹהִי לְהָבִיא אֶת הַבְּשׂוֹרָה לְרוֹמָא!"
      },
      medium: {
        question: "לִפְנֵי מִי הֵעִיד פּוֹלוֹס לִפְנֵי יְצִיאָתוֹ?",
        options: [
          "הַסַּנְהֶדְרִין",
          "הַמֶּלֶךְ אַגְרִיפַּס וּבֶרְנִיקֵי",
          "חַיָּלִים רוֹמִיִּים",
          "הֶהָמוֹן הַיְּהוּדִי"
        ],
        correctAnswer: 1,
        hint: "מַלְכוּת הוֹרְדוֹסִית מְיֻהֶדֶת",
        funFact: "👑 מֵרוֹעֵה צֹאן לְאַרְמוֹן מַלְכוּתִי - עֲלִיָּה אֱלֹהִית שֶׁל פּוֹלוֹס!"
      },
      hard: {
        question: "אֵיךְ הָאֱלֹהִים מְשַׁתֵּף אֶת הַמַּעֲרָכוֹת הָאֱנוֹשִׁיּוֹת בִּתְכְנִיתוֹתָיו?",
        options: [
          "הוּא מִתְעַלֵּם מֵהֶן",
          "הוּא מְשַׁתֵּף אוֹתָן בְּהַשְׁגָּחָה לְהַגְשִׁים אֶת מַטְרוֹתָיו",
          "הוּא מַשְׁמִיד אוֹתָן",
          "הוּא תָּמִיד מִתְנַגֵּד לָהֶן"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּרִבּוֹנוּת אֱלֹהִית עַל הַהִיסְטוֹרְיָה",
        funFact: "🌐 צֶדֶק רוֹמִי הוֹפֵךְ לִכְלִי שֶׁל הַבְּשׂוֹרָה - הַשְׁגָּחָה יוֹצֵאת דֹּפֶן!"
      }
    },

    82: {
      name: "טְבִיעָה בְּמַלְטָה",
      challenge: "אַל תִּירָא, פּוֹלוֹס; עָלֶיךָ לַעֲמֹד לִפְנֵי קֵיסָר...",
      easy: {
        question: "בְּאֵיזֶה אִי טָבְעָה סְפִינָתוֹ שֶׁל פּוֹלוֹס?",
        options: ["כְּרֵתִים", "קַפְרִיסִין", "מַלְטָה", "סִיצִילְיָה"],
        correctAnswer: 2,
        hint: "אִי קָטָן מִדְּרוֹם לְסִיצִילְיָה",
        funFact: "🏝️ מַלְטָה: עֲצִירָה כְּפוּיָה הוֹפֶכֶת לְשְׁלִיחוּת פּוֹרִיָּה - סִטְיוֹת אֱלֹהִיּוֹת!"
      },
      medium: {
        question: "אֵיזֶה נֵס עָשָׂה פּוֹלוֹס בְּמַלְטָה?",
        options: [
          "הִרְגִּיעַ אֶת הַסְּעָרָה",
          "רִפֵּא אֶת אֲבִי פּוּבְּלִיוֹס וַחוֹלִים אֲחֵרִים",
          "הִרְבָּה אֹכֶל",
          "הֶחֱיָה מֵת"
        ],
        correctAnswer: 1,
        hint: "רִפּוּאוֹת מְרֻבּוֹת בָּאִי",
        funFact: "🏥 פּוֹלוֹס: מִטּוֹבֵעַ לְרוֹפֵא נִסִּי - מוּנִיטִין אֱלֹהִי!"
      },
      hard: {
        question: "אֵיךְ הַטְּבִיעָה הַזֹּאת מְמַחִישָׁה אֶת נֶאֱמָנוּת הָאֱלֹהִים?",
        options: [
          "תְּאוּנוֹת קוֹרוֹת",
          "הָאֱלֹהִים מֵגֵן וּמְקַיֵּם אֶת הַבְטָחוֹתָיו לַמְרוֹת הַמִּכְשׁוֹלִים",
          "לְפוֹלוֹס הָיָה מַזָּל",
          "זֶה הָיָה נִמְנָע"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּנֶאֱמָנוּת אֱלֹהִית לְהַבְטָחוֹת",
        funFact: "⛈️ סְעָרָה, טְבִיעָה, נָחָשׁ: שׁוּם דָּבָר לֹא עוֹצֵר אֶת הַתּוֹכְנִית הָאֱלֹהִית לְפוֹלוֹס!"
      }
    },

    83: {
      name: "פּוֹלוֹס בְּרוֹמָא",
      challenge: "שָׁהָה שְׁנָתַיִם שְׁלֵמוֹת בְּבַיִת שֶׁשָּׂכַר לְעַצְמוֹ...",
      easy: {
        question: "בְּאֵילוּ תְּנָאִים חָי פּוֹלוֹס בְּרוֹמָא?",
        options: [
          "בְּבֵית כֶּלֶא סָגוּר",
          "בְּמַעֲצָר בַּיִת",
          "בְּחֵרוּת מֻחְלֶטֶת",
          "בְּגָלוּת"
        ],
        correctAnswer: 1,
        hint: "חֵרוּת יַחֲסִית תַּחַת פִּקּוּחַ",
        funFact: "🏠 בַּיִת-כֶּלֶא הוֹפֵךְ לְמֶרְכָּז שְׁלִיחוּתִי - חֵרוּת בְּכְבָלִים!"
      },
      medium: {
        question: "מָה עָשָׂה פּוֹלוֹס בְּמֶשֶׁךְ שְׁנָתָיו בְּרוֹמָא?",
        options: [
          "נָח",
          "לִמֵּד וְכָתַב אֶת אִגְּרוֹתָיו",
          "הֵכִין אֶת הַהֲגַנָּתוֹ",
          "עָשָׂה תִּיּוּר"
        ],
        correctAnswer: 1,
        hint: "שֵׁרוּת אִינְטֶנְסִיבִי לַמְרוֹת הַכְּבָלִים",
        funFact: "✍️ אִגְּרוֹת הַשְּׁבִי: אֶפְסִיִּים, פִילִיפִּים, קוֹלוֹסִים, פִילֵימוֹן!"
      },
      hard: {
        question: "אֵיךְ סִיֵּם פּוֹלוֹס אֶת שֵׁרוּתוֹ לְפִי הַמָּסוֹרֶת?",
        options: [
          "מֵת מִמַּחֲלָה",
          "נֶעֱרַף תַּחַת נֵירוֹן בְּסָבִיב 67 לַסְּפִירָה",
          "מֵת מִזִּקְנָה",
          "נֶעֱלַם בְּאֹפֶן מִסְתּוֹרִי"
        ],
        correctAnswer: 1,
        hint: "קִדּוּשׁ הַשֵּׁם תַּחַת הָקֵיסָר הַמְּשֻׁגָּע",
        funFact: "⚔️ 'נִלְחַמְתִּי אֶת הַמִּלְחָמָה הַטּוֹבָה, סִיַּמְתִּי אֶת הַמֶּרוּץ' - נִצָּחוֹן סוֹפִי!"
      }
    },

    84: {
      name: "הָאִגֶּרֶת לָרוֹמִיִּים",
      challenge: "אֵינִי בוֹשׁ בִּבְשׂוֹרַת הַמָּשִׁיחַ, כִּי הִיא כֹּחַ אֱלֹהִים לִישׁוּעָה...",
      easy: {
        question: "אֵיזוֹ אִגֶּרֶת מְפַתַּחַת בִּיּוֹתֵר אֶת דּוֹקְטְרִינַת הַיְשׁוּעָה בֶּאֱמוּנָה?",
        options: ["קוֹרִינְתִיִּים א'", "גַּלָטִים", "רוֹמִיִּים", "אֶפְסִיִּים"],
        correctAnswer: 2,
        hint: "ה'קָתֶדְרָלָה' הַתֵּאוֹלוֹגִית שֶׁל פּוֹלוֹס",
        funFact: "🏛️ רוֹמִיִּים: יְצִירַת מוֹפֵת תֵּאוֹלוֹגִית שֶׁהִמְרָה אֶת אוֹגוּסְטִינוּס וְלוּתֶר!"
      },
      medium: {
        question: "לְפִי רוֹמִיִּים, אֵיךְ מִצְטַדֵּק הָאָדָם לִפְנֵי הָאֱלֹהִים?",
        options: [
          "עַל יְדֵי מַעֲשָׂיו הַטּוֹבִים",
          "עַל יְדֵי אֱמוּנָה בִּלְבַד, בְּלִי מַעֲשִׂים",
          "עַל יְדֵי קָרְבָּנוֹת",
          "עַל יְדֵי מָסוֹרֶת"
        ],
        correctAnswer: 1,
        hint: "עִקָּרוֹן יְסוֹדִי שֶׁל הָרֵפוֹרְמָצְיָה",
        funFact: "⚖️ 'הַצַּדִּיק בֶּאֱמוּנָתוֹ יִחְיֶה' - מַהְפֵּכָה רוּחָנִית שֶׁל פּוֹלוֹס!"
      },
      hard: {
        question: "מָה הִיא הַהִתְייַחֲסוּת הָאוּנִיבֶרְסָלִית שֶׁל אִגֶּרֶת זוֹ?",
        options: [
          "הִיא נוֹגַעַת רַק לָרוֹמִיִּים",
          "הִיא חוֹשֶׂפֶת אֶת תּוֹכְנִית הַיְשׁוּעָה לְכָל הָאֱנוֹשׁוּת",
          "הִיא רַק מְבַקֶּרֶת אֶת רוֹמָא",
          "הִיא מְיֻשֶּׁנֶת"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּתוֹכְנִית הַיְשׁוּעָה הָאוּנִיבֶרְסָלִית",
        funFact: "🌍 הַבְּשׂוֹרָה = כֹּחַ אֱלֹהִים לַכֹּל: יְהוּדִים וִיוָנִים - אוּנִיבֶרְסָלִיּוּת מֻחְלֶטֶת!"
      }
    },

    85: {
      name: "שִׁיר הָאַהֲבָה - קוֹרִינְתִיִּים א' 13",
      challenge: "אִם אֲדַבֵּר בִּלְשׁוֹנוֹת בְּנֵי אָדָם וּמַלְאָכִים, וְאַהֲבָה אֵין לִי...",
      easy: {
        question: "אֵיזֶה פֶּרֶק בַּתַּנַ״ךְ נִקְרָא 'שִׁיר הָאַהֲבָה'?",
        options: [
          "קוֹרִינְתִיִּים א' 12",
          "קוֹרִינְתִיִּים א' 13",
          "יוֹחָנָן א' 4",
          "רוֹמִיִּים 8"
        ],
        correctAnswer: 1,
        hint: "הַפֶּרֶק הַמֶּרְכָּזִי בְּקוֹרִינְתִיִּים א'",
        funFact: "💝 הַפֶּרֶק הַנִּקְרָא בִּיּוֹתֵר בְּחֲתוּנוֹת - הַגְדָרָה מֻשְׁלֶמֶת שֶׁל אַהֲבָה!"
      },
      medium: {
        question: "מָה אוֹמֵר פּוֹלוֹס עַל מֶשֶׁךְ הָאַהֲבָה?",
        options: [
          "הָאַהֲבָה חוֹלֶפֶת עִם הַזְּמַן",
          "הָאַהֲבָה לֹא תִּפּוֹל לְעוֹלָם",
          "הָאַהֲבָה תְּלוּיָה בַּנְּסִיבוֹת",
          "הָאַהֲבָה זְמַנִּית"
        ],
        correctAnswer: 1,
        hint: "נִצְחִיּוּת הָאַהֲבָה הָאֱלֹהִית",
        funFact: "♾️ רַק הָאַהֲבָה חוֹצָה מָוֶת וְנֶצַח - עֵרֶךְ עֶלְיוֹן!"
      },
      hard: {
        question: "לָמָּה פּוֹלוֹס מַעֲמִיד אֶת הָאַהֲבָה מֵעַל לְמַתָּנוֹת רוּחָנִיּוֹת?",
        options: [
          "הַמַּתָּנוֹת רָעוֹת",
          "הָאַהֲבָה נוֹתֶנֶת מַשְׁמָעוּת וְעֵרֶךְ לְכָל הַשְּׁאָר",
          "הָאַהֲבָה יוֹתֵר קַלָּה",
          "הַמַּתָּנוֹת מְפַלְּגוֹת"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בַּמְּנוֹעַ וּבְמַשְׁמָעוּת שֶׁל כָּל שֵׁרוּת",
        funFact: "🎯 בְּלִי אַהֲבָה, אֲפִילוּ הַמַּתָּנוֹת הַגְּדוֹלוֹת בִּיּוֹתֵר הוֹפְכוֹת לְרַעַשׁ וְגַאֲוָה!"
      }
    },

    86: {
      name: "אֶפְסִיִּים: הַקְּהִילָּה גּוּף הַמָּשִׁיחַ",
      challenge: "הִשְׁפִּיל הַכֹּל תַּחַת רַגְלָיו, וְאוֹתוֹ נָתַן לְרֹאשׁ עַל הַכֹּל לַקְּהִילָּה...",
      easy: {
        question: "לְפִי אֶפְסִיִּים, מָה הַקְּהִילָּה בְּיַחֲסָהּ לַמָּשִׁיחַ?",
        options: [
          "מִקְדָּשׁוֹ",
          "גּוּפוֹ",
          "מִשְׁפַּחְתּוֹ",
          "צְבָאוֹ"
        ],
        correctAnswer: 1,
        hint: "מֵטָפוֹרָה אוֹרְגָנִית שֶׁל אַחְדּוּת",
        funFact: "👤 גּוּף הַמָּשִׁיחַ: כָּל נוֹצְרִי הוּא אֵבֶר חִיּוּנִי - תְּלוּת הֲדָדִית!"
      },
      medium: {
        question: "אֵיזוֹ שִׁרְיוֹן מְתָאֵר פּוֹלוֹס לַקְּרָב הָרוּחָנִי?",
        options: [
          "שִׁרְיוֹן פִיזִי",
          "שִׁרְיוֹן אֱלֹהִים: אֱמֶת, צֶדֶק, שָׁלוֹם, אֱמוּנָה, יְשׁוּעָה, דְּבַר ה'",
          "שִׁרְיוֹן רוֹמִי",
          "הֲגַנָּה קִסְמִית"
        ],
        correctAnswer: 1,
        hint: "שֵׁשׁ חֲלָקִים שֶׁל שִׁרְיוֹן רוּחָנִי",
        funFact: "⚔️ קְרָב רוּחָנִי בְּכֵלֵי נֶשֶׁק רוּחָנִיִּים - אֶסְטְרָטֶגְיָה אֱלֹהִית לְנִצָּחוֹן!"
      },
      hard: {
        question: "נֶגֶד מִי הַמַּאֲבָק הָאֲמִתִּי שֶׁלָּנוּ לְפִי פּוֹלוֹס?",
        options: [
          "נֶגֶד אֲנָשִׁים רָעִים",
          "נֶגֶד כֹּחוֹת רוּחָנִיִּים שֶׁל רֶשַׁע",
          "נֶגֶד מֶמְשָׁלוֹת",
          "נֶגֶד עֹנִי"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּכֹחוֹת רוּחָנִיִּים בִּלְתִּי נִרְאִים",
        funFact: "👹 קְרָב קוֹסְמִי: מֵאֲחוֹרֵי סִכְסוּכִים אֱנוֹשִׁיִּים, מִלְחָמָה רוּחָנִית אֲמִתִּית!"
      }
    },

    87: {
      name: "פִילִיפִּים: הַשִּׂמְחָה בַּנִּסָּיוֹן",
      challenge: "שִׂמְחוּ בַּה' תָּמִיד; שׁוּב אוֹמַר: שִׂמְחוּ!",
      easy: {
        question: "אֵיזֶה רֶגֶשׁ מְעוֹדֵד פּוֹלוֹס לַמְרוֹת כְּלִיאָתוֹ?",
        options: ["הִשְׁלָמָה", "שִׂמְחָה", "כַּעַס", "עֶצֶב"],
        correctAnswer: 1,
        hint: "רֶגֶשׁ מַפְתִּיעַ לְאָסִיר",
        funFact: "😊 שִׂמְחָה 16 פְּעָמִים בְּ-4 פְּרָקִים - שִׂיא שֶׁל אֹשֶׁר בַּכֶּלֶא!"
      },
      medium: {
        question: "לְפִי פִילִיפִּים 2, אֵיזוֹ גִישָׁה אִמֵּץ יֵשׁוּעַ?",
        options: [
          "הוּא כָּפָה אֶת עַצְמוֹ בְּכֹחַ",
          "הוּא הוֹרִיק וְהִשְׁפִּיל אֶת עַצְמוֹ עַד מָוֶת",
          "הוּא בָּרַח מֵאַחֲרָיוּת",
          "הוּא חִיפֵּשׂ כָּבוֹד"
        ],
        correctAnswer: 1,
        hint: "תְּנוּעָה יוֹרֶדֶת רְצוֹנִית",
        funFact: "📉 יֵשׁוּעַ: מִשִּׁוְיוֹן עִם אֱלֹהִים לְמָוֶת עַל הַצְּלָב - אַהֲבָה קִיצוֹנִית!"
      },
      hard: {
        question: "אֵיךְ פּוֹלוֹס יָכוֹל לְהַטִּיף שִׂמְחָה בַּכֶּלֶא?",
        options: [
          "הוּא מַעֲמִיד פָּנִים",
          "שִׂמְחָה נוֹצְרִית חוֹרֶגֶת מֵהַנְּסִיבוֹת",
          "הוּא מָזוֹכִיסְט",
          "הוּא מַכְחִישׁ אֶת הַמְּצִיאוּת"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּשִׂמְחָה עַל-טִבְעִית",
        funFact: "✨ שִׂמְחָה = פְּרִי הָרוּחַ בִּלְתִּי תָּלוּי בַּנְּסִיבוֹת - סוֹד אֱלֹהִי!"
      }
    },

    88: {
      name: "הָאִגְּרוֹת הָרוֹעִיּוֹת",
      challenge: "הִלָּחֵם אֶת מִלְחֶמֶת הָאֱמוּנָה הַטּוֹבָה, אֱחֹז בְּחַיֵּי הָעוֹלָם...",
      easy: {
        question: "לְמִי כָּתַב פּוֹלוֹס אֶת אִגְּרוֹתָיו הָרוֹעִיּוֹת הָאַחֲרוֹנוֹת?",
        options: [
          "לַקּוֹרִינְתִיִּים",
          "לְטִימוֹתִיּוֹס וְטִיטוֹס",
          "לָרוֹמִיִּים",
          "לַגַּלָטִים"
        ],
        correctAnswer: 1,
        hint: "בָּנָיו הָרוּחָנִיִּים וְשׁוּתָפָיו",
        funFact: "👨‍👦 צַוָּאָה רוּחָנִית: פּוֹלוֹס מַעֲבִיר אֶת הַלַּפִּיד לַדּוֹר הַבָּא!"
      },
      medium: {
        question: "אֵיזוֹ עֵצָה נוֹתֵן פּוֹלוֹס לִבְחִירַת מַנְהִיגֵי קְהִילָּה?",
        options: [
          "לִבְחוֹר אֶת הָעֲשִׁירִים בִּיּוֹתֵר",
          "לִבְחוֹר לְפִי קְרִיטֶרְיוֹנִים מוּסָרִיִּים וְרוּחָנִיִּים מַחְמִירִים",
          "לִבְחוֹר אֶת הַמְּשֻׁכְּלָלִים בִּיּוֹתֵר",
          "לִבְחוֹר אֶת הַפּוֹפּוּלָרִיִּים בִּיּוֹתֵר"
        ],
        correctAnswer: 1,
        hint: "כִּשּׁוּרִים מוּסָרִיִּים קוֹדֵם כֹּל",
        funFact: "⚖️ תְּקָנִים גְּבוֹהִים לְמַנְהִיגִים: אֹפִי לִפְנֵי יְכֹלֶת - סְדָרֵי עֲדִיפֻיּוֹת אֱלֹהִיִּים!"
      },
      hard: {
        question: "אֵיזוֹ יְרֻשָּׁה מַשְׁאִיר פּוֹלוֹס לְטִימוֹתִיּוֹס?",
        options: [
          "רְכוּשׁ חֻמְרִי",
          "נֶאֱמָנוּת לַבְּשׂוֹרָה וְהַשֵּׁרוּת הָרוֹעִי",
          "תַּפְקִיד פּוֹלִיטִי",
          "בֵּית סֵפֶר תֵּאוֹלוֹגִי"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בִּירֻשָּׁה רוּחָנִית",
        funFact: "📜 'שְׁמוֹר אֶת הַפִּקָּדוֹן הַטּוֹב' - הַעֲבָרָה נֶאֱמָנָה שֶׁל הַבְּשׂוֹרָה דֶּרֶךְ הַדּוֹרוֹת!"
      }
    },

    89: {
      name: "עִבְרִים: יֵשׁוּעַ כֹּהֵן גָּדוֹל",
      challenge: "יֵשׁ לָנוּ כֹּהֵן גָּדוֹל שֶׁעָבַר אֶת הַשָּׁמַיִם...",
      easy: {
        question: "לְפִי עִבְרִים, מִי הוּא הַכֹּהֵן הַגָּדוֹל שֶׁלָּנוּ?",
        options: ["אַהֲרֹן", "מֹשֶׁה", "יֵשׁוּעַ", "מַלְכִּי-צֶדֶק"],
        correctAnswer: 2,
        hint: "הַמְּתַוֵּךְ הַמֻּשְׁלָם בֵּין אֱלֹהִים וּבְנֵי אָדָם",
        funFact: "✝️ יֵשׁוּעַ: כֹּהֵן וְקָרְבָּן - קָרְבָּן מֻשְׁלָם פַּעַם אַחַת לָנֶצַח!"
      },
      medium: {
        question: "לָמָּה כְּהֻנַּת יֵשׁוּעַ עֲדִיפָה עַל זוֹ שֶׁל אַהֲרֹן?",
        options: [
          "הִיא עַתִּיקָה יוֹתֵר",
          "הִיא נִצְחִית עַל-פִּי סֵדֶר מַלְכִּי-צֶדֶק",
          "הִיא עֲשִׁירָה יוֹתֵר",
          "הִיא פּוֹפּוּלָרִית יוֹתֵר"
        ],
        correctAnswer: 1,
        hint: "נִצְחִיּוּת מוּל זְמַנִּיּוּת",
        funFact: "♾️ כְּהֻנָּה נִצְחִית: יֵשׁוּעַ מְתַוֵּךְ בְּעַדֵּנוּ לָעַד!"
      },
      hard: {
        question: "אֵיךְ עִבְרִים מַצִּיגָה אֶת הַבְּרִית הַחֲדָשָׁה?",
        options: [
          "זֶהָה לַיְשָׁנָה",
          "עֲדִיפָה וְסוֹפִית, כְּתוּבָה בַּלְּבָבוֹת",
          "זְמַנִּית",
          "אוֹפְּצְיוֹנָלִית"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּהַשְׁלָמָה וְעֲלִיָּה",
        funFact: "📋 בְּרִית חֲדָשָׁה: תּוֹרָה כְּתוּבָה בַּלְּבָבוֹת, לֹא עַל אֶבֶן!"
      }
    },

    90: {
      name: "יַעֲקֹב: אֱמוּנָה וּמַעֲשִׂים",
      challenge: "הָאֱמוּנָה בְּלִי מַעֲשִׂים מֵתָה הִיא...",
      easy: {
        question: "לְפִי יַעֲקֹב, מָה צָרִיךְ לְלַוּוֹת אֶת הָאֱמוּנָה?",
        options: [
          "מִלִּים",
          "מַעֲשִׂים",
          "רְגָשׁוֹת",
          "יְדִיעָה"
        ],
        correctAnswer: 1,
        hint: "בִּטּוּי מַעֲשִׂי שֶׁל אֱמוּנָה",
        funFact: "🌳 אֱמוּנָה = שֹׁרֶשׁ, מַעֲשִׂים = פֵּרוֹת - עֵץ רוּחָנִי שָׁלֵם!"
      },
      medium: {
        question: "לְמָה יַעֲקֹב מְדַמֶּה אֶת הַלָּשׁוֹן?",
        options: [
          "לְחֶרֶב",
          "לְאֵשׁ קְטַנָּה שֶׁמַּדְלִיקָה יַעַר גָּדוֹל",
          "לִכְלִי נְגִינָה",
          "לִכְלִי"
        ],
        correctAnswer: 1,
        hint: "אֵבֶר קָטָן אֲבָל כֹּחַ הֶרֶס גָּדוֹל",
        funFact: "🔥 לָשׁוֹן: אֵבֶר קָטָן אֲבָל יָכוֹל לְהַדְלִיק חַיִּים שְׁלֵמִים - זְהִירוּת!"
      },
      hard: {
        question: "אֵיךְ לְהַשְׁלִים בֵּין יַעֲקֹב וּפוֹלוֹס עַל אֱמוּנָה/מַעֲשִׂים?",
        options: [
          "הֵם סוֹתְרִים זֶה אֶת זֶה",
          "פּוֹלוֹס מְדַבֵּר עַל צִדּוּק, יַעֲקֹב עַל קְדֻשָּׁה",
          "אֶחָד טוֹעֶה",
          "אֵין פִּתְרוֹן"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בִּשְׁנֵי הִבְּטִים מַשְׁלִימִים",
        funFact: "⚖️ פּוֹלוֹס: נוֹשָׁעִים בֶּאֱמוּנָה / יַעֲקֹב: אֱמוּנָה מוּכַּחַת בְּמַעֲשִׂים - הַרְמוֹנְיָה מֻשְׁלֶמֶת!"
      }
    },

    91: {
      name: "הִתְגַּלּוּת: שִׁיבַת הַמֶּלֶךְ",
      challenge: "הִנְנִי בָּא מְהֵרָה. אַשְׁרֵי הַשּׁוֹמֵר אֶת דִּבְרֵי נְבוּאַת הַסֵּפֶר הַזֶּה!",
      easy: {
        question: "לְכַמָּה קְהִילּוֹת כּוֹתֵב יוֹחָנָן בַּהִתְגַּלּוּת?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "מִסְפַּר הַשְּׁלֵמוּת",
        funFact: "⛪ 7 קְהִילּוֹת אַסְיָה: רְאִי שֶׁל כָּל הַקְּהִילּוֹת בְּכָל הַזְּמַנִּים!"
      },
      medium: {
        question: "אֵיךְ הַסִּפּוּר מִסְתַּיֵּם לְפִי הִתְגַּלּוּת?",
        options: [
          "הֶרֶס מֻחְלָט",
          "שָׁמַיִם חֲדָשִׁים וָאָרֶץ חֲדָשָׁה",
          "חֲזָרָה לְגַן עֵדֶן הָאַרְצִי",
          "סוֹף כָּל קִיּוּם"
        ],
        correctAnswer: 1,
        hint: "חִידּוּשׁ מֻשְׁלָם שֶׁל הַבְּרִיאָה",
        funFact: "🌅 לֹא סוֹף הָעוֹלָם אֶלָּא חִידּוּשׁ מֻחְלָט - תִּקְוָה סוֹפִית!"
      },
      hard: {
        question: "אֵיזֶה מֶסֶר מֶרְכָּזִי מַעֲבִירָה הִתְגַּלּוּת לַנִּרְדָּפִים?",
        options: [
          "הִשְׁלִימוּ",
          "הַמָּשִׁיחַ שׁוֹלֵט וְיִנְצַח בְּסוֹפוֹ שֶׁל דָּבָר",
          "בִּרְחוּ מֵהָרְדִיפָה",
          "הִתְנַקְּמוּ"
        ],
        correctAnswer: 1,
        hint: "מְדֻבָּר בְּתִקְוָה לְנִצָּחוֹן סוֹפִי",
        funFact: "👑 'אֲשֶׁר הָיָה וְהֹוֶה וְיָבוֹא' - אֲדוֹן הַהִיסְטוֹרְיָה וְהַזְּמַן!"
      }
    }
  }
};

export default chapter7Translations;
